import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import userReducer from "../features/user/userSlice";
import lotListReducer from "features/lotlist/lotListSlice";
import lotOfferReducer from "features/lotOffer/lotOfferSlice";
import lotLocationsReducer from "features/lotLocations/lotLocationsSlice";
import shoppingCartReducer from "features/shoppingCart/shoppingCartSlice";
import customerReducer from "features/customer/customerSlice";
import agentListReducer from "features/agentList/agentListSlice";
import sellersListReducer from "features/sellersList/sellersListSlice";
import sellerReducer from "features/seller/sellerSlice";
import newSellerReducer from "features/seller/newSellerSlice";
import agentReducer from "features/agent/agentSlice";
import tableReducer from "features/table/tableSlice";
import filterAndSortReducer from 'features/lotlist/filterAndSortSlice'
import certificateTypesReducer from 'features/certificateTypes/certificateTypesSlice';
import taxationKindsReducer from 'features/taxationKinds/taxationKindsSlice';
// Redux Persist
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  createMigrate,
} from "redux-persist";

import storage from "redux-persist/lib/storage";

const migrations = {
   3: (state: any) => {
    if (state && state.shoppingCart && state.shoppingCart.articles) {
      return state;
    }
    // Reset shopping cart state if articles are missing to prevent errors with old persisted states
    return {
      ...state,
      shoppingCart: {
        ...state.shoppingCart,
        articles: [],
      },
    };
  },
  // 4: (state: any) => {
  //   return {
  //     ...state,
  //     counter: undefined,
  //     user: undefined,
  //     lotList: undefined,
  //     lotOffer: undefined,
  //     lotLocations: undefined,
  //     shoppingCart: undefined,
  //     customerSettings: undefined,
  //     agentList: undefined,
  //     sellersList: undefined,
  //     seller: undefined,
  //     newSeller: undefined,
  //     agent: undefined,
  //     table: undefined,
  //     filterAndSort: undefined,
  //     certificateTypes: undefined,
  //     taxationKinds: undefined,
  //   };
  // },
};

const persistConfig = {
  key: "root",
  version: 3,
  storage,
  blacklist: ['agent'],
  migrate: createMigrate(migrations, { debug: false }),
};
const agentPersistConfig = {
  key: "agent",
  version: 1,
  storage,
  blacklist: ['registered']
}

const reducers = combineReducers({
  counter: counterReducer,
  user: userReducer,
  lotList: lotListReducer,
  lotOffer: lotOfferReducer,
  lotLocations: lotLocationsReducer,
  shoppingCart: shoppingCartReducer,
  customerSettings: customerReducer,
  agentList: agentListReducer,
  sellersList: sellersListReducer,
  seller: sellerReducer,
  newSeller: newSellerReducer,
  agent: persistReducer(agentPersistConfig, agentReducer),
  table: tableReducer,
  filterAndSort: filterAndSortReducer,
  certificateTypes: certificateTypesReducer,
  taxationKinds: taxationKindsReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export const persistore = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
